import { showErrorToast, showGenericErrorToast } from '@/shared/toasts';

export function apiErrorHandler(error?: any) {
  const errors = error?.response?.data;
  if (errors && errors[0]) {
    showErrorToast(errors[0].message);
  } else {
    showGenericErrorToast();
  }
}
